// extracted by mini-css-extract-plugin
export default {"button":"CryButton_button__OytrE"};